import { Component, OnInit } from '@angular/core';
import { productWatchService } from '../../products/products.service';

@Component({
	selector: 'pm-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css', '../../app.component.css'],
})
export class HeaderComponent implements OnInit {
	productImg: string;
	productTitle: string;
	pathInit = `../../../assets/images/`;

	ngOnInit() {
		productWatchService.productImage.subscribe(img => {
			if (img === '') {
				// tslint:disable-next-line:max-line-length
				this.productImg = this.pathInit + 'clear.png';
			} else {
				this.productImg = this.pathInit + img;
			}
		});
		productWatchService.productTitle.subscribe(title => {
			this.productTitle = title;
		});
	}
}
